"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextField = exports.Title = exports.Container = void 0;
const styles_1 = require("@mui/material/styles");
const text_field_1 = require("../../text-field");
const typography_1 = __importDefault(require("../../typography"));
exports.Container = (0, styles_1.styled)("div")({
    padding: 0,
    display: "flex",
    flexFlow: "column wrap",
    margin: "12px 0"
});
exports.Title = (0, styles_1.styled)(typography_1.default)({
    paddingBottom: "18px"
});
exports.StyledTextField = (0, styles_1.styled)(text_field_1.TextField)({
    marginTop: "16px"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmFkaW9Hcm91cFN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9idXR0b24tcmFkaW8tZ3JvdXAvc3R5bGVzL1JhZGlvR3JvdXBTdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsaURBQThDO0FBQzlDLGlEQUE2QztBQUM3QyxrRUFBMEM7QUFFN0IsUUFBQSxTQUFTLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUM7SUFDckMsT0FBTyxFQUFFLENBQUM7SUFDVixPQUFPLEVBQUUsTUFBTTtJQUNmLFFBQVEsRUFBRSxhQUFhO0lBQ3ZCLE1BQU0sRUFBRSxRQUFRO0NBQ2pCLENBQUMsQ0FBQztBQUVVLFFBQUEsS0FBSyxHQUFHLElBQUEsZUFBTSxFQUFDLG9CQUFVLENBQUMsQ0FBQztJQUN0QyxhQUFhLEVBQUUsTUFBTTtDQUN0QixDQUFDLENBQUM7QUFFVSxRQUFBLGVBQWUsR0FBRyxJQUFBLGVBQU0sRUFBQyxzQkFBUyxDQUFDLENBQUM7SUFDL0MsU0FBUyxFQUFFLE1BQU07Q0FDbEIsQ0FBQyxDQUFDIn0=